export class Regex {
  public static readonly url = /(^|\s)((https?:\/\/)?[\w-]+(\.[\w-]+)+\.?(:\d+)?(\/\S*)?)/gi;
  public static readonly phone = /[- +()0-9]+/gi;
}
